module.exports = __webpack_public_path__ + "img/success.0e020cb6.png";